export default __webpack_public_path__ + "static/media/logoLoginDentalNew.a0bd3101.jpeg";